import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import DeleteMaterialContent from "./DeleteMaterialContent";

export const DeleteMaterialDialog = () => {
  return (
    <HubDialogWrapper maxWidth="sm" name="delete-material">
      <DeleteMaterialContent />
    </HubDialogWrapper>
  );
};

export default DeleteMaterialDialog;
